export default __webpack_public_path__ + "static/media/homepage_module_recipients.6e9b7e9a.png";